import React from 'react';
import './single-card.scss';
import type { SingleCardProps } from '../../types';
import LoginPhoto from '../../assets/images/Sage-Login-Photo.jpg';

export default function SingleCard({ title, description, children }: React.PropsWithChildren<SingleCardProps>) {
	return (
		<div className={'single-card'}>
			<img src={LoginPhoto} />
			<div className='card-wrapper'>
				<div className={'dx-card content'}>
					<div className={'header'}>
						<div className={'title'}>{title}</div>
						<div className={'description'}>{description}</div>
					</div>
					{children}
				</div>
			</div>

		</div>
	)
}
